var _path, _path2, _path3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNavMobileShowroom(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 301 293",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M38.5 7.5c74.67-.333 149.336 0 224 1a327963.46 327963.46 0 0130.5 57c.5 73.666.667 147.333.5 221H5.5c-.333-73.336 0-146.67 1-220a2503.59 2503.59 0 0032-59zm2 6c73.003-.333 146.003 0 219 1a3824.126 3824.126 0 0028 51.5c-91.667.667-183.333.667-275 0a1323.592 1323.592 0 0028-52.5zm-29 58h277v43h-277v-43zm0 48h277v162h-108v-144h-60v144h-109v-162zm14 24a1521.522 1521.522 0 0178-1v108c-26.002.167-52.002 0-78-.5a1419.697 1419.697 0 000-106.5zm100-1c16.67-.167 33.337 0 50 .5a4815.3 4815.3 0 00-1 138.5h-49v-139zm71 0h78v108h-78v-108z",
    opacity: 0.793
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M20.5 137.5h88v118h-88v-118zm5 6a1419.697 1419.697 0 010 106.5c25.998.5 51.998.667 78 .5v-108c-26.172-.331-52.172.002-78 1z",
    opacity: 0.767
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M191.5 137.5h88v118h-88v-118zm5 5v108h78v-108h-78z",
    opacity: 0.805
  })));
}

export default __webpack_public_path__ + "600845381e30ae6fb902cdd9ca1d3ec5.svg";
export { SvgNavMobileShowroom as ReactComponent };